import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { FBFieldTypeId } from '../models/fb-field-type-id.enum';
import { noWhitespaceValidator, emailValidator } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class FormControlService {

  constructor() { }

  toFormGroup(fields: any[]) {
    let group: any = {};

    fields.forEach(field => {
      let syncValidators: ValidatorFn[] = [];

      if (field.fieldTypeId === FBFieldTypeId.SkillDropdown || field.isRequired) {
        syncValidators.push(Validators.required);
        syncValidators.push(noWhitespaceValidator());
      }

      if (field.fieldTypeId === FBFieldTypeId.CustomerEmail) {
        syncValidators.push(emailValidator());
      }

      group[field.rowId] = new FormControl('', syncValidators);
    });

    return new FormGroup(group);
  }

  addFormControl(formGroup: FormGroup, controlName: string, required: boolean = false) {
    let syncValidators: ValidatorFn[] = [];
    if (required) syncValidators.push(Validators.required);
    let control = new FormControl('', syncValidators);
    formGroup.addControl(controlName, control);
  }

  isRequiredControl(abstractControl: AbstractControl): boolean {
    if (abstractControl.validator) {
      const validator = abstractControl.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }

    if (abstractControl['controls']) {
      for (const controlName in abstractControl['controls']) {
        if (abstractControl['controls'][controlName]) {
          if (this.isRequiredControl(abstractControl['controls'][controlName])) {
            return true;
          }
        }
      }
    }

    return false;
  }
}
